import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import Box from '@audioeye-marketing/ui/src/components/Box'
import LinkButton from '@audioeye-marketing/ui/src/components/LinkButton'
import ArrowLeft from '@audioeye/ui-icons/Line/Arrows/ArrowLeft'
import Frame from '@/components/storyblok/global/Frame'
import PostHero from '@/components/post/PostHero'
import PostFooter from '@/components/post/PostFooter'
import ShareArticle from '@/components/misc/ShareArticle'
import ScannerOnlySection from '@/components/misc/ScannerOnlySection'
import TableOfContents from '@/components/misc/TableOfContents'

const Post = async ({ blok, rels, fullSlug, relatedPosts }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <Frame blok={blok?.frame?.content} rels={rels}>
        <PostHero
          author={blok?.author}
          publishedDate={blok?.published_date}
          updatedDate={blok?.last_updated_date}
          title={blok?.title}
          summary={blok?.summary}
          image={blok?.social_banner}
          topics={blok?.topic}
        />
        <Stack direction={{ xs: 'column', lg: 'row' }} justifyContent="center">
          <TableOfContents
            pageData={blok}
            constraint={!blok?.body?.[0]?.component?.includes('Rich Text Content') ? 'lg' : 'sm'}
            backButton={
              <LinkButton href="/blog/" size="sm" variant="plain" startDecorator={<ArrowLeft />} sx={{ mb: 3 }}>
                Back to Blog
              </LinkButton>
            }
          />
          {/* 754 is calculated by the max width of rich text + 40 padding on both sides for our md padding section */}
          <Box sx={{ width: '100%', maxWidth: '754px', margin: { xs: '0 auto', lg: 'inherit' } }}>
            <ScannerOnlySection />
            {blok?.body?.map((currentSection, index) => (
              <StoryblokServerComponent
                blok={currentSection}
                key={currentSection?._uid}
                rels={rels}
                headingLevel={2}
                imagePriority={index === 0}
                lowerHeadingStyles
                padding="sm"
              />
            ))}
            <ShareArticle fullSlug={fullSlug} padding="sm" />
          </Box>
        </Stack>
        <PostFooter relatedPosts={relatedPosts} />
      </Frame>
    </div>
  )
}

export default Post
